// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout-module--layout--1UUe8","mainContent":"Layout-module--mainContent--32MEO"};